import React, { Fragment, ReactElement, useState } from "react"
import moment from "moment"

interface ISeesionnedEventProps {
  index: number
  link: string
  dateInfo: Array<{ date: string; duration: number }>
  participants: number
  quotas: number
  selectedEventIndex: number
  setSelectedEventIndex: (index: number) => void
}

const SessionnedEvent = ({
  index,
  link,
  dateInfo,
  participants,
  quotas,
  selectedEventIndex,
  setSelectedEventIndex
}: ISeesionnedEventProps) => {
  return (
    <div key={link} onClick={() => setSelectedEventIndex(index)}>
      <div>
        <input
          type="radio"
          name="event"
          value="huey"
          checked={selectedEventIndex === index}
        />
        <div>
          <div>
            {dateInfo.map(({ date, duration }) => {
              const momentStartDate = moment(date).format("dddd DD MMMM YYYY")
              const startDate =
                momentStartDate[0].toUpperCase() + momentStartDate.substr(1)

              const startTime = moment(date).format("LT")
              const endTime = moment(date)
                .add(duration, "m")
                .format("LT")
              return (
                <div>
                  <time>{startDate}</time>
                  <span>{`${startTime} - ${endTime}`}</span>
                </div>
              )
            })}
          </div>
          <div>{`Places disponibles: ${quotas - participants}`}</div>
        </div>
      </div>
    </div>
  )
}

interface INormalEventProps {
  index: number
  event: {
    link: string
    quotas: number
    participants: number
    start: string
  }
  duration: number
  selectedEventIndex: number
  setSelectedEventIndex: (index: number) => void
}

const NormalEvent = ({
  index,
  event: { link, quotas, participants, start },
  duration,
  selectedEventIndex,
  setSelectedEventIndex
}: INormalEventProps) => {
  const momentStartDate = moment(start).format("dddd DD MMMM YYYY")
  const startDate = momentStartDate[0].toUpperCase() + momentStartDate.substr(1)
  const startTime = moment(start).format("LT")
  const endTime = moment(start)
    .add(duration, "m")
    .format("LT")

  return (
    <div key={link} onClick={() => setSelectedEventIndex(index)}>
      <div>
        <input
          type="radio"
          name="event"
          value="huey"
          checked={selectedEventIndex === index}
        />
        <div>
          <div>
            <time>{startDate}</time>
            <span>{`${startTime} - ${endTime}`}</span>
          </div>
          <div>{`Places disponibles: ${quotas - participants}`}</div>
        </div>
      </div>
    </div>
  )
}

export { NormalEvent, SessionnedEvent }
